module.exports = __webpack_public_path__ + "static/media/btn-comment-on.db9edd5f.svg";